import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import ApiService, { initialAuthState } from "../Services/ApiServices";
import { useIndependenceDayTheme } from "../../lib/useIndependenceDayTheme";
import LoginPage from "../Login/Login";
import IndependenceDayLogin from "./IndependenceDayLogin";
// import "../Login/Login.css";

/* ------------------------------------------------------------------------
 * Date gate for /login.
 *
 * Off-festival this renders the untouched LoginPage. On 15 August it swaps in
 * the themed shell and hands it the same OTP request the normal page makes,
 * so the auth flow is byte-for-byte identical either way.
 * ---------------------------------------------------------------------- */

export default function LoginGate() {
    const festive = useIndependenceDayTheme();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    if (!festive) return <LoginPage />;

    const sendOtp = async (phone) => {
        if (phone.length !== 10) {
            alert("Enter a valid 10-digit number");
            return;
        }

        try {
            setLoading(true);
            const response = await ApiService.post("otp/sendClientOtp", {
                companyCode: initialAuthState.companyCode,
                unitCode: initialAuthState.unitCode,
                phoneNumber: phone,
            });

            if (response.status) {
                navigate("/verify-otp", { state: { phone } });
            } else {
                alert("Error sending OTP");
            }
        } catch (error) {
            console.error("OTP error:", error);
        } finally {
            setLoading(false);
        }
    };

    return <LoginPage onContinue={sendOtp} loading={loading} />;
}
